import { Box, Grid, Typography, Button, Pagination } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { useEffect, useState } from "react";
import Viewer from "../../components/common/DockViewer";
import { Color } from "molstar/lib/mol-util/color";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateSmilesById } from "./dockingSlice";

function AutoDockViewer() {
  const [page, setPage] = useState<number>(1);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const dockingModuleProperties = useSelector(
    (state: any) => state.dockingModule.properties
  );

  useEffect(() => {
    // console.log("ligand_url",dockingModuleProperties.ligand_url)
    if (!dockingModuleProperties.ligand_url) {
      navigate("/virtual-screening/docking/autodock/");
    }
    var pdbqt1 =
      dockingModuleProperties.autoDockdata.protein_url ||
      "/samples/autodock/ace2.pdbqt";
    var pdbqt2 = dockingModuleProperties.ligand_url;
    // console.log("pdbqt2",pdbqt2);
    // console.log("pdbqt1",pdbqt1);
    setPage(dockingModuleProperties.id + 1);

    Viewer.create("molviewer", [Color(0x33dd22), Color(0x1133ee)], true).then(
      (viewer) => {
        viewer.loadStructuresFromUrlsAndMerge([
          { url: pdbqt1, format: "pdbqt" },
          { url: pdbqt2, format: "pdbqt" },
        ]);
      }
    );
  }, [dockingModuleProperties]);

  // const handleNavigation = (navigationStep: string) => {
  //   const newId =
  //     navigationStep === "next"
  //       ? dockingModuleProperties.id + 1
  //       : dockingModuleProperties.id - 1;
  //   dispatch(updateSmilesById({ id: newId }));
  // };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
    dispatch(updateSmilesById({ id: value - 1 }));
  };

  return (
    <>
      {/* {dockingModuleProperties?.evaluationIds.length > 1 && (
        <Grid
          container
          md={10}
          my={2}
          mx={"auto"}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Grid item sx={{ width: "49.5%" }}>
            <Button
              variant="outlined"
              fullWidth
              disabled={dockingModuleProperties?.id <= 0}
              color="primary"
              startIcon={<ChevronLeft />}
              onClick={() => handleNavigation("prev")}
            >
              Prev
            </Button>
          </Grid>

          <Grid item sx={{ width: "49.5%" }}>
            <Button
              variant="contained"
              fullWidth
              disabled={
                dockingModuleProperties?.id ==
                dockingModuleProperties?.evaluationIds.length - 1
              }
              color="primary"
              endIcon={<ChevronRight />}
              onClick={() => handleNavigation("next")}
            >
              Next
            </Button>
          </Grid>
        </Grid>
      )} */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 2,
        }}
      >
        <Pagination
          count={dockingModuleProperties?.evaluationIds.length}
          variant="outlined"
          shape="rounded"
          size="large"
          color="primary"
          siblingCount={5}
          boundaryCount={5}
          page={page}
          onChange={handleChange}
        />
      </Box>

      <Box
        width="79%"
        p={1}
        sx={{
          margin: "auto",
          backgroundColor: "#cce5ff",
          borderRadius: 1,
          border: "1.5px solid #b8daff",
          marginBottom: 1,
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Box
              width="100%"
              sx={{
                display: "flex",
                alignItems: "center",
                height: "100%",
                flexWrap: "wrap",
              }}
            >
              <Typography
                className="wrap-word"
                sx={{
                  color: "#004085",
                  fontWeight: 700,
                  fontSize: 18,
                }}
              >
                {dockingModuleProperties.SMILES}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              width="100%"
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                color: "rgb(61, 32, 168);",
                fontWeight: "bold",
              }}
            >
              Docking Score : {dockingModuleProperties.Docking_Score}
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Grid
        item
        xs={12}
        md={12}
        sx={{
          m: 0,
          pl: 1,
          pr: 1,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          id="molviewer"
          style={{
            height: "700px",
            width: "100%",
            position: "relative",
            display: "flex", // Add display flex
            justifyContent: "center", // Center horizontally
            alignItems: "center", // Center vertically
          }}
        ></div>
      </Grid>
    </>
  );
}

export default AutoDockViewer;
